(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const pickers = document.querySelectorAll('variant-picker');

    pickers.forEach((picker) => {
      const inventoryWrapper = picker.querySelector('[data-variant-inventory-wrapper]');
      const inventoryText = picker.querySelector('[data-variant-inventory-text]');

      if (!inventoryWrapper || !inventoryText) return;

      const template =
        inventoryWrapper.dataset.stockTextTemplate ||
        inventoryWrapper.getAttribute('data-stock-text-template') ||
        '';

      function updateFromElement(el) {
        if (!el) return;

        const management = el.getAttribute('data-inventory-management');
        if (management !== 'shopify') {
          inventoryText.textContent = '';
           return;
        }

        const qtyAttr = el.getAttribute('data-inventory-qty');
        if (qtyAttr === null) {
          inventoryText.textContent = '';
          return;
        }

        const count = Number(qtyAttr);
        if (Number.isNaN(count)) {
          inventoryText.textContent = '';
          return;
        }

        if (!template) {
          inventoryText.textContent = 'In stock: ' + count;
        } else {
          inventoryText.textContent = template.replace('__COUNT__', count);
        }
      }

      const checkedRadio = picker.querySelector('input[type="radio"][data-variant-id][data-inventory-qty][data-current-checked="true"]')
        || picker.querySelector('input[type="radio"][data-variant-id][data-inventory-qty]:checked');

      if (checkedRadio) {
        updateFromElement(checkedRadio);
      } else {
        const selectedOption = picker.querySelector('select.variant-option__select option[data-variant-id][data-inventory-qty][selected]');
        if (selectedOption) {
          updateFromElement(selectedOption);
        }
      }

      picker.addEventListener('change', (event) => {
        const target = event.target;

        if (target.matches('input[type="radio"][data-variant-id][data-inventory-qty]')) {
         updateFromElement(target);
        }

        if (target.matches('select.variant-option__select')) {
          const selected = target.selectedOptions && target.selectedOptions[0];
          if (selected && selected.hasAttribute('data-inventory-qty')) {
            updateFromElement(selected);
          }
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
